module.exports = __webpack_public_path__ + "media/images/fama-cbbee25b6b7427b9e5dd2766f0600e3e.png";